import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import UsersOverviewUserTaskPill from './UsersOverviewUserTaskPill';

/*
    TODO requires restructuring of Users screen:
    Keeps track of all userTasks on project for user
    manages removal of userTask / removal of all usertasks
    manages task quota change
    manages saving all changes on usertasks for managed project
*/
class UsersOverviewProjectPill extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    handleProjectClick = () => {
        this.props.handleProjectClick(this.props.project);
    };

    countFiltered() {
        return this.props.userTasks.filter(task => ((this.props.showActiveTasks && (task.active && !task.taskClosed))
        || (this.props.showClosedTasks && (!task.active || task.taskClosed)))).length
    }

    render = () => {

        let hasVisibleTasks = this.countFiltered();

        return ( !hasVisibleTasks ? null :
            <div className="panel panel-default panel-pmtask" >
                <div className="panel-heading" role="tab" id="headingThree-outer">
                    <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                    <a style={{"cursor" : "pointer"}} onClick={this.handleProjectClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                        <span className={this.props.isActive ? "md-expand-more" : "md-chevron-right"}/>
                        {this.props.project.name}
                        <p className="pull-right">{this.props.project.projectArchived ? "[Archived]" : ""}</p>
                    </a>
                    </h4>
                </div>
                <div id="collapseThree-outer" className={this.props.isActive ? "panel-collapse" : "panel-collapse collapse"} role="tabpanel" aria-labelledby="headingThree">
                    <div className="panel-body">
                        {
                            this.props.userTasks ? this.props.userTasks.map((userTask, index) => {
                                        if(this.props.showActiveTasks && !this.props.showClosedTasks && !userTask.taskClosed && userTask.active) {
                                            return (<UsersOverviewUserTaskPill
                                                        currentQuota = {userTask.quota}
                                                        handleQuotaBlur = {this.props.handleExistingQuotaBlur}
                                                        handleRemove = {this.props.handleRemoveExisting}
                                                        key={index}
                                                        quotaError = {this.props.quotaError}
                                                        quotaEditing = {this.props.quotaEditing}
                                                        userTask = {userTask}
                                                        />);
                                        }
                                        else if(!this.props.showActiveTasks && this.props.showClosedTasks && (userTask.taskClosed || !userTask.active)) {
                                            return (<UsersOverviewUserTaskPill
                                                        currentQuota = {userTask.quota}
                                                        handleQuotaBlur = {this.props.handleExistingQuotaBlur}
                                                        handleRemove = {this.props.handleRemoveExisting}
                                                        key={index}
                                                        quotaError = {this.props.quotaError}
                                                        quotaEditing = {this.props.quotaEditing}
                                                        userTask = {userTask}
                                                        />);
                                        }
                                        else if(this.props.showActiveTasks && this.props.showClosedTasks) {
                                            return (<UsersOverviewUserTaskPill
                                                        currentQuota = {userTask.quota}
                                                        handleQuotaBlur = {this.props.handleExistingQuotaBlur}
                                                        handleRemove = {this.props.handleRemoveExisting}
                                                        key={index}
                                                        quotaError = {this.props.quotaError}
                                                        quotaEditing = {this.props.quotaEditing}
                                                        userTask = {userTask}
                                                        />);
                                        } else { return null; }
                            }) : null
                        }
                        {
                            this.props.newlyAssigned ?
                                this.props.newlyAssigned.map((userTask, index) => {
                                    if (userTask.projectName == this.props.project.name) {
                                        return (<UsersOverviewUserTaskPill
                                                currentQuota = {userTask.quota}
                                                handleQuotaBlur = {this.props.handleNewlyAssignedQuotaBlur}
                                                handleExistingQuotaChange = {this.props.handleNewlyAssignedQuotaChange}
                                                handleQuotaClick = {this.props.handleNewlyAssignedQuotaClick}
                                                handleRemove = {this.props.handleRemoveNew}
                                                key={index}
                                                newlyAssigned
                                                quotaError = {this.props.quotaError}
                                                quotaEditing = {this.props.quotaEditing}
                                                userTask = {userTask}
                                                />);
                                    } else {
                                        return null;
                                    }
                                })
                            : null
                        }
                    </div>
                    <div className="panel-footer">
                        <button title="Save changes" ref="updateButton" onClick={this.props.handleToggleModal} className="btn btn-discrete">REMOVE ALL ASSIGNMENTS</button>
                        <button onClick={this.props.handleProjectSave} className="btn btn-default">Update tasks</button>
                    </div>
                </div>
            </div>
        );
    };
}

UsersOverviewProjectPill.propTypes = {
    dispatch: PropTypes.func,
    handleExistingQuotaBlur: PropTypes.func,
    handleExistingQuotaChange: PropTypes.func,
    handleExistingQuotaClick: PropTypes.func,
    handleNewlyAssignedQuotaBlur: PropTypes.func,
    handleNewlyAssignedQuotaChange: PropTypes.func,
    handleNewlyAssignedQuotaClick: PropTypes.func,
    handleProjectClick: PropTypes.func,
    handleProjectSave: PropTypes.func,
    handleRemoveExisting: PropTypes.func,
    handleRemoveNew: PropTypes.func,
    handleToggleModal: PropTypes.func,
    isActive: PropTypes.bool,
    newlyAssigned: PropTypes.array,
    project: PropTypes.object,
    quotaError: PropTypes.bool,
    showActiveTasks: PropTypes.bool,
    showClosedTasks: PropTypes.bool,
    userTaskIDToIsEditingQuotaMap: PropTypes.array,
    userTasks: PropTypes.array,
};

UsersOverviewProjectPill.defaultProps = {
    isActive: false,
    quotaError: false,
    showActiveTasks: true,
    showClosedTasks: false,
};

const mapStateToProps = (state) => {
    // TODO list of userTasks on this project is currently passed from parent component. better solution would be to pass them through store.
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersOverviewProjectPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverviewProjectPill.js
 **/